import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.module.scss'

class Row extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isHover: false,
    }
  }

  render() {
    const { innerRef, className, children, ...rest } = this.props
    const { isHover } = this.state

    return (
      <div
        {...rest}
        ref={innerRef}
        className={classnames(styles.row, className)}
        onMouseEnter={() => this.setState({ isHover: true })}
        onMouseLeave={() => this.setState({ isHover: false })}
      >
        {React.Children.map(children, child => {
          if (!child) {
            return undefined
          }

          return React.cloneElement(child, { ...child.props, isRowHover: isHover })
        })}
      </div>
    )
  }
}

Row.defaultProps = {
  innerRef: undefined,
  className: undefined,
}

Row.propTypes = {
  children: PropTypes.node.isRequired,
  innerRef: PropTypes.func,
  className: PropTypes.string,
}

export default Row
